import React ,{useEffect} from 'react';
import AOS from 'aos';
import Banner from '../Components/Pages/HelpCenter/Banner';
import Categories from '../Components/Pages/HelpCenter/Categories';
import Header from '../Components/Shared/Header/Header';
import Jobs from '../Components/Pages/AboutUs/Jobs';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function HelpCenter(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header />
        <Banner />
        <Categories />
        <Jobs />
        <Start />
        <Footer />
        </>
    )
};
export default HelpCenter;